import {defineStore} from "pinia";

import AxiosClass from "@/classes/axios.js";
import { useAuthUserStore } from "@/store/auth.js";
import { useEnumsStore } from "@/store/enums.js";
import GeneralClass from "@/classes/general.js";

const axios = new AxiosClass();
const general = new GeneralClass();

export const useMobileHomeStore = defineStore('mobileHome', {
    state: () => ({
        enumsStore: useEnumsStore(),
        payPeriod: {},
        week: {},
        currentDate: general.getToday(),
        employeProjectList: [],
        timesheet: {},
        timesheets: [],
        selectedEmploye: {},
        dataChanged: false,
        dateStart: general.getWeekDay(general.getToday()) === 0 
                    ? general.getFromDate(general.getByWeekday(general.getToday(), 1), 'subtract', 1, 'week') 
                    : general.getByWeekday(general.getToday(), 1),
    }),
    getters: {
        isDataChanged: (state) => state.dataChanged,
    },
    actions: {
        async getData() {
            this.selectedEmploye = {...useAuthUserStore().fullUserDetails};
            await this.getPayPeriodForEmploye();
            await this.getProjectListForEmploye('TE');
        },
        getFullDates() { 
            let weekObj = {
                date_start: this.dateStart,
                date_end: general.getByWeekday(general.getFromDate(this.dateStart, 'add', 1, 'week'), 0),
                weekNumber: general.getWeekNumber(this.dateStart),
                dates: [],
            };
            
            for (let day = 0; day < 7; day++) {
                weekObj.dates.push({date: general.getFromDate(this.dateStart, 'add', day, 'day')});
            }

            this.week = weekObj;
        },
       async getPayPeriodForEmploye() {
            await axios.post('/PayPeriodForEmployeMobile',{date: this.dateStart, userId: this.selectedEmploye.id}).then((response) => {
                this.payPeriod = response;
            });
        },
        async createTimesheet(period, employeId) {
            let createdTimesheet = null;
            await axios.post(`/TimesheetCreate`, {period: period, employeId: employeId}).then(async (response) => {
                await this.getPayPeriodForEmploye();
                createdTimesheet = response;
            });

            return createdTimesheet;
        },
        getTimesheetForWeek() {
            if (Object.keys(this.payPeriod).length > 0) {
                return this.payPeriod.timesheet?.find(timesheet =>
                    general.isDateSame(timesheet.date_start, this.week.date_start)
                    && general.isDateSame(timesheet.date_end, this.week.date_end)
                );   
            }
        },
        async getTimesheet() {
            let timesheet = this.getTimesheetForWeek();
            if (timesheet === undefined) {
                timesheet = await this.createTimesheet(this.week, this.selectedEmploye.id);
            }
            return timesheet
        },
        async getProjectListForEmploye(entryType) {
            await axios.get(`/ProjectsAssignedForEmploye/${this.selectedEmploye.id}/${entryType}`).then((response) => {
                this.employeProjectList = general.orderBy(response, 'name');
            });
        },
        getProjectForType(typeId) {
            return general.orderBy(
                this.employeProjectList?.filter(project => project.project_type_id === typeId), 'name'
            );
        },
        getRequisitionForProject(projectId, requisition_id = null) {
            const project = this.employeProjectList?.find(project => project.id === projectId);
            if (project === undefined) { return [];}
            
            return ((requisition_id) ? project.requisition.find(req => req.id === requisition_id) : general.orderBy(project.requisition, 'code'));
        },
        isCompleted(entry) {
            return (entry.entry_status_id === this.enumsStore.EntryStatus.COMPLETED.id);
        },
        isApproved(entry, isTimeentry = false) {
            return (entry.entry_status_id === this.enumsStore.EntryStatus.ACCEPTED.id && ((!isTimeentry) ? this.isPaid(entry) : true));
        },
        isDenied(entry, isTimeentry = false) {
            return (entry.entry_status_id === this.enumsStore.EntryStatus.REFUSED.id && ((!isTimeentry) ? this.isPaid(entry) : true));
        },
        isPaid(entry) {
            return (entry.paid_expense_id !== null);
        },
        hasRT(entry) {
            return (entry.rt_id !== null);
        },
        async getTimesheets() {
            this.selectedEmploye = {...useAuthUserStore().fullUserDetails};
            await axios.get(`/TimesheetsForEmployeMobile/${this.selectedEmploye.id}`).then((response) => {
                this.timesheets = response;
            });

            return this.timesheets;
        },
        checkMaxLength(target, length) {
            if (target.value.length > length) {
                target.value = target.value.slice(0, length);
            }
            return target.value;
        },
        setDataChanged(value) {
            if (value === this.dataChanged) { return; }
            this.dataChanged = value;
        },
        clear() {
            this.$reset();
        },
    },
    persist: {
        storage: sessionStorage,
        paths: ['payPeriod', 'week', 'currentDate', 'employeProjectList', 'timesheet', 'selectedEmploye'],
    },
})